import React from 'react'
import { FormInput, FormDate, FormButton } from '@myxplor/forms'
import { PlusIcon, DeleteIcon } from '@myxplor/icons'

import { TypeAheadSelect } from '../../../../ui/forms/type-ahead'
import Grid from '../../../../ui/grid'
import { rolePositions, roleIsOther, statesAU } from './states'

const defaultValue = {
  serviceName: undefined,
  position: undefined,
  positionText: undefined,
  streetLine1: undefined,
  suburb: undefined,
  state: undefined,
  postcode: undefined,
  periodFrom: undefined,
  periodTo: undefined,
}

export const defaultValues = {
  EmployedInAService: [],
}

export const EmployedInAService = ({
  onChange,
  addKey,
  removeKey,
  errorAtKey,
  loading,
  values = {},
  errors = {},
}) => (
  <div>
    <fieldset>
      <legend>Previous Employment/Work in Child Care Service</legend>
        Has the person has been employed in or worked in a child care service(s) in the past five (5)
        years. This includes experience working with children in any child care setting
    </fieldset>

    {values.EmployedInAService.map((service = {}, i) => (
      <div className="formValues--nested" key={i}>
        <fieldset>
          <legend>Name and Position</legend>
          <Grid>
            <FormInput
              name={`EmployedInAService[${i}].serviceName`}
              value={service.serviceName}
              label="Name of the service"
              maxLength={120}
              onChange={onChange}
              loading={loading}
              errors={errorAtKey({ key: `EmployedInAService[${i}].serviceName`, errors })}
              required
              compact
            />

            <TypeAheadSelect
              name={`EmployedInAService[${i}].position`}
              label="Position of the personnel in the service"
              value={service.position}
              errors={errorAtKey({ key: `EmployedInAService[${i}].position`, errors })}
              options={rolePositions}
              onChange={onChange}
              loading={loading}
              required
              compact
            />

            {roleIsOther(service) && (
              <FormInput
                name={`EmployedInAService[${i}].positionText`}
                label="Position of the personnel"
                hint="Since you selected &quot;Other&quot;, please describe the role"
                value={service.positionText}
                errors={errorAtKey({ key: `EmployedInAService[${i}].positionText`, errors })}
                maxLength={150}
                onChange={onChange}
                loading={loading}
                required
                compact
              />
            )}
          </Grid>
        </fieldset>

        <fieldset>
          <legend>Address</legend>
          <Grid>
            <FormInput
              name={`EmployedInAService[${i}].streetLine1`}
              value={service.streetLine1}
              errors={errorAtKey({ key: `EmployedInAService[${i}].streetLine1`, errors })}
              label="Street"
              maxLength={60}
              onChange={onChange}
              loading={loading}
              required
              compact
            />

            <FormInput
              name={`EmployedInAService[${i}].suburb`}
              value={service.suburb}
              errors={errorAtKey({ key: `EmployedInAService[${i}].suburb`, errors })}
              label="Suburb"
              maxLength={40}
              onChange={onChange}
              loading={loading}
              required
              compact
            />

            <TypeAheadSelect
              name={`EmployedInAService[${i}].state`}
              value={service.state}
              errors={errorAtKey({ key: `EmployedInAService[${i}].state`, errors })}
              label="State"
              options={statesAU}
              onChange={onChange}
              loading={loading}
              required
              compact
            />

            <FormInput
              name={`EmployedInAService[${i}].postcode`}
              value={service.postcode}
              errors={errorAtKey({ key: `EmployedInAService[${i}].postcode`, errors })}
              label="Postcode"
              maxLength={4}
              onChange={onChange}
              loading={loading}
              required
              compact
            />
          </Grid>
        </fieldset>

        <fieldset>
          <legend>Duration at service </legend>
          <Grid>
            <FormDate
              name={`EmployedInAService[${i}].periodFrom`}
              value={service.periodFrom}
              errors={errorAtKey({ key: `EmployedInAService[${i}].periodFrom`, errors })}
              label="From"
              onChange={onChange}
              loading={loading}
              required
              compact
            />
            <FormDate
              name={`EmployedInAService[${i}].periodTo`}
              value={service.periodTo}
              errors={errorAtKey({ key: `EmployedInAService[${i}].periodTo`, errors })}
              label="To"
              onChange={onChange}
              loading={loading}
              required
              compact
            />
          </Grid>
        </fieldset>

        <FormButton
          destructive
          confirm={`Deleting ${service.serviceName ||
              'this service'} can not be undone. Are you sure?`}
          onClick={e => {
            e.preventDefault()
            removeKey(`EmployedInAService[${i}]`)
          }}>
          <DeleteIcon left />
            Delete Employment in a Service
        </FormButton>
      </div>
    ))}

    <FormButton
      onClick={e => {
        e.preventDefault()
        addKey('EmployedInAService', { ...defaultValue })
      }}>
      <PlusIcon left />Add new Employment in a Service
    </FormButton>
  </div>
)



// WEBPACK FOOTER //
// ./src/providers-registrations/personnel-list/register-mancon-action/form/employed-in-a-service.jsx